import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { G as n, H as p, E as c, I as b } from "../../vendor-CPVnY93G.js";
import { Checkbox as f } from "../Checkbox/index.js";
import { c as t } from "../../styles.module-BF2N4g8-.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as $ } from "../../utils/omitStyleRenderProps/index.js";
function h({
  columns: r,
  children: i,
  ...l
}) {
  const { selectionBehavior: d, selectionMode: s, allowsDragging: o } = n(), a = o ? 40 : 48;
  return /* @__PURE__ */ m(p, { ...$(l), className: t.tableHeader, children: [
    o && /* @__PURE__ */ e(c, { "data-drag-cell": !0, width: 48, minWidth: 48, maxWidth: 48, className: t.column }),
    d === "toggle" && /* @__PURE__ */ e(
      c,
      {
        "data-selection-cell": !0,
        width: a,
        minWidth: a,
        maxWidth: a,
        className: t.column,
        children: s === "multiple" && /* @__PURE__ */ e(f, { "aria-label": "Select all", slot: "selection" })
      }
    ),
    /* @__PURE__ */ e(b, { items: r, children: i })
  ] });
}
h.displayName = "Table.Header";
export {
  h as Header
};
